jQuery( function( $ ) {
	var ProductPhotoswipe = function( $target ) {
		this.$target = $target;
		this.$images = $( '.product__media-item[data-media-type="image"]', $target );
		// No images? Abort.
		if ( 0 === this.$images.length ) {
			return;
		}
		// Pick functionality to initialize...
		this.photoswipe_enabled = typeof PhotoSwipe !== 'undefined';
		// Bind functions to this.
		this.getGalleryItems = this.getGalleryItems.bind( this );
		this.initPhotoswipe = this.initPhotoswipe.bind( this );
		this.openPhotoswipe = this.openPhotoswipe.bind( this );
		if ( this.photoswipe_enabled ) {
			this.initPhotoswipe();
		}
	};
	/*** Init PhotoSwipe.*/
	ProductPhotoswipe.prototype.initPhotoswipe = function() {
		var $this = this;
		var $gallery = this.$target.closest('.product-main-slider');
		if (!$gallery.length) {
			$gallery = this.$target;
		}
		$gallery.on( 'click', '.product-gallery-photoswipe__trigger', function (e) {
			$this.openPhotoswipe(e);
		});
		$gallery.on( 'click', '.product-media.media-image img:not(.zoomImg)', function (e) {
			// Hover zoom is hidden below 1200px and cannot be used on touch devices.
			if (!window.ZOOM || !window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)').matches) {
				$this.openPhotoswipe(e);
			}
		});
	};
	/*** Get product gallery image items.*/
	ProductPhotoswipe.prototype.getGalleryItems = function() {
		var $slides = this.$images = $( '.product__media-item[data-media-type="image"]:not(.swiper-slide-duplicate)', this.$target ),
			items   = [];
		if ( $slides.length > 0 ) {
			$slides.each( function( i, el ) {
				var img = $( el ).find( 'img:not(.zoomImg)' ).first();
				if ( img.length ) {
					items.push({
						src  : img.attr( 'data-master-image' ),
						msrc : img[0].currentSrc || img.attr( 'src' ),
						w    : img.attr( 'data-master-image-width' ),
						h    : img.attr( 'data-master-image-height' ),
						title: img.attr( 'data-caption' ) ? img.attr( 'data-caption' ) : ''
					});
				}
			});
		}
		return items;
	};
	/*** Open photoswipe modal.*/
	ProductPhotoswipe.prototype.openPhotoswipe = function( e ) {
		e.preventDefault();
		var pswpElement = document.querySelector('.pswp'),
			eventTarget = $( e.target ),
			clicked;
			clicked = eventTarget.closest('.product__media-item');
			if (!clicked.length && this.$target.hasClass('swiper')) {
				clicked = this.$target.find('.swiper-slide-active');
			}
		var items = this.getGalleryItems();
		if (clicked.hasClass('swiper-slide-duplicate')) {
			var mediaId = clicked.attr('data-media-id');
			clicked = this.$images.filter(function() {
				return $(this).attr('data-media-id') === mediaId;
			});
		}
		var index = this.$images.index(clicked);
		if (!pswpElement || !items.length || index < 0) {
			return;
		}
		var photoswipe_additional_options = {
			"shareEl": false,
			"history": false,
			"closeOnScroll": false,
			"bgOpacity": 0.85,
			"closeOnVerticalDrag": false
		};
			var options = $.extend( {
				index: index,
				addCaptionHTMLFn: function( item, captionEl ) {
					return false;
					if ( ! item.title ) {
						captionEl.children[0].textContent = '';
						return false;
					}
					captionEl.children[0].textContent = item.title;
					return true;
				}
			}, photoswipe_additional_options);

		// Initializes and opens PhotoSwipe.
		var photoswipe = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
		photoswipe.init();
	};
	/** Initialize all galleries on page.*/
	$('.product-image-main, .product-style-2-main-img').each(function(){
		var psws = new ProductPhotoswipe($(this));
	});
});
